// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"553":"164aae3c","977":"aa0263a0"}[chunkId] + ".chunk.js";
};